import React, {useState} from 'react'
import styled from 'styled-components'

import {StepOne,StepTwo} from './Steps'

const SignupForm = ({ setOpen, setCookie, ...props }) => {
    const [step, setStep] = useState(0)
    const [formData, setFormData] = useState({
        FIRSTNAME: '',
        LASTNAME: '',
        EMAIL: ''
    })
    return (
        <React.Fragment>
                {step === 0 ? (
                    <StepOne
                        step={step}
                        setStep={setStep}
                        formData={formData}
                        setFormData={setFormData}
                        setCookie={setCookie}
                        simpleWithButton={props.simpleWithButton}
                        blockSignupTitle={props.blockSignupTitle}
                        blockSignupSubtitle={props.blockSignupSubtitle}
                        blockSignupLink={props.blockSignupLink}
                        blockSignupTerms={props.blockSignupTerms}
                    />
                ) : (
                    ''
                )}
                {step === 1 ? (
                    <StepTwo
                        step={step}
                        setStep={setStep}
                        formData={formData}
                        setFormData={setFormData}
                        setOpen={setOpen}
                    />
                ) : (
                    ''
                )}

        </React.Fragment>
    )
}

export default SignupForm
